import React from 'react'
import Journal from '../components/Journal'

const MyJournal = () => {
  return (
    <div>
      <Journal/>
    </div>
  )
}

export default MyJournal
